module.exports = __webpack_public_path__ + "img/20230829234609.1de5cba9.png";